export const FEEDBACK_COPY = {
  greeting: "Hi!",
  accept: "Sure!",
  decline: "No thanks.",
  close: "Close",
  back: "Previous question",
  progress: (step: number, total: number) => `${step} of ${total}`,
  commentPlaceholder: "Optional",
  skip: "Skip",
  next: "Next",
  send: "Send",
  thanks: "Thanks for your feedback!",
  followUp: "Let our support team follow up by email",
  thanksFollowUp: "Thanks! Our support team will get back to you by email.",
  sendFailed: "We couldn't send your feedback.",
  retry: "Try again",
} as const;
